import classNames from 'classnames'
import React from 'react'
import {shouldShowSaleEndsLabel} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import c from '../../../../../classnames.scss'
import {Price} from '../price'
import {SaleEndsLabel} from '../../../parts/labels/sale-ends-label'
import {TicketDescription} from './ticket-description'
import s from './ticket-name-column.scss'
import {TicketNameColumnProps} from './index'

export const TicketNameColumn = ({ticket}: TicketNameColumnProps) => {
  const {t} = useTranslation()
  const {id, name, description} = ticket

  return (
    <>
      <h4
        className={classNames(c.evTicketNameColor, c.evTicketNameFont)}
        data-hook="name"
        role="cell"
        aria-label={`${t('ticketsThankYou.ticketName')}: ${name}`}
      >
        {name}
      </h4>
      <Price className={classNames(s.ticketNamePrice, c.evTextFont, c.evTextColor)} ticket={ticket} />
      {shouldShowSaleEndsLabel(ticket) && <SaleEndsLabel endDate={ticket.salePeriod.formattedSaleEndDate} />}
      {description && (
        <div className={s.description}>
          <TicketDescription ticketDefId={id} description={description} />
        </div>
      )}
    </>
  )
}
